import { MappedReportPointOfInterests, Point3d } from '@/types';
import { Number3 } from '@fabric-web/3d-viewer';
import { UNCERTAIN_PROFILE_LABEL } from '../constants';
import { UnitsEnum, UnitSystemEnum } from '@/__generated__/graphql';
import { localiseMeasurement } from './unitSystem';

export const getPoiCoordinates = (
  centerPoint3d: { x: number; y: number } | undefined | null,
  cadTransform: [number, number, number, number, number, number] | number[] | undefined | null
) => {
  if (!centerPoint3d || !cadTransform) return;

  const [xx_scale, xy_scale, offset_x, yx_scale, yy_scale, offset_y] = cadTransform;
  const cx = centerPoint3d.x * xx_scale + centerPoint3d.y * xy_scale + offset_x;
  const cy = centerPoint3d.x * yx_scale + centerPoint3d.y * yy_scale + offset_y;
  return { cx, cy };
};

type DeckType = NonNullable<MappedReportPointOfInterests['paintRegion']>['deck'];

export const getDeckDetails = (deck: DeckType | undefined) => {
  if (!deck) return;
  const { resourcePath, imageDimensions, cadTransform } = deck;
  return { resourcePath, imageDimensions, cadTransform };
};

export const point3dToNumber3 = (
  point: Point3d | null | undefined,
  heightOffset?: number
): Number3 | undefined => {
  if (!point) return undefined;
  const { x, y, z } = point;
  return [x, y, z + (heightOffset ?? 0)];
};

export const getBlisterHeightValueDisplay = (
  unitSystem: UnitSystemEnum,
  height: number | null | undefined
) => {
  if (!height || height === 0) return UNCERTAIN_PROFILE_LABEL;
  return (
    localiseMeasurement({
      unitSystem,
      value: height,
      sourceUnit: UnitsEnum.Meter,
      displayAsUnit: UnitsEnum.Millimeter,
      showUnitLabel: true,
    }) ?? UNCERTAIN_PROFILE_LABEL
  );
};
